import { useQuery, UseQueryOptions } from 'react-query';
import { fetchUserByUserProfileId } from './api';
import type { UserPreview } from './types';

type UseUserByProfileId = {
    eventId: number;
    userProfileId: string | number | null;
    options?: UseQueryOptions;
};

export const useUserByProfileId = ({
    eventId,
    userProfileId,
    options = {},
}: UseUserByProfileId) => {
    const enabled = options.enabled ?? (!!eventId && !!userProfileId);

    return useQuery<UserPreview, Error>(
        ['people_user', userProfileId],
        () => fetchUserByUserProfileId(eventId, userProfileId),
        // thus have been added to extends query options
        // prevent refetching data for our needs
        // and be able to update stored cache
        {
            enabled,
            ...(!!options.staleTime && { staleTime: options.staleTime }),
            ...(!!options.cacheTime && { cacheTime: options.cacheTime }),
        }
    );
};
